import { LogLevel } from '../types/logLevel';
import { Versionable } from '../types/versionable';

export enum SmscMode {
  TRANSCEIVER = 'TRANSCEIVER',
  RECEIVER = 'RECEIVER',
  TRANSMITTER = 'TRANSMITTER',
}

export interface SmscObject {
  readonly smscId: string;
  readonly logFile: string;
  readonly logLevel: LogLevel;
  readonly connections: Array<{
    readonly host: string;
    readonly port: string;
    readonly mode: SmscMode;
    readonly systemType?: string;
    readonly username: string;
    readonly password: string;
    readonly sourceAddrTon: number;
    readonly sourceAddrNpi: number;
    readonly destAddrTon: number;
    readonly destAddrNpi: number;
    readonly enquireLinkInterval: number;
    readonly instances: number;
    readonly throughput: number;
    readonly throughputMt?: number;
    readonly throughputMo?: number;
  }>;
}

export interface SmscModel extends Versionable {
  readonly object: SmscObject;
}
